import React from 'react';

const SzTopBar = () => {
    return (
        <div className="header_top_bar">
            <div className="container-fluid justify-content-center">
                <div className="row justify-content-center">
                    <div className="col-auto text-center">
                        <aside id="text-15" className="widget_text">
                            <div className="textwidget">
                                <ul className="list-group list-group-horizontal top_bar_info clearfix">
                                    <li className="">
                                        <a id="szde" target="_blank" href="https://www.sueddeutsche.de"
                                           className="">SZ.de</a>
                                    </li>
                                    <li className="">
                                        <a id="zeitung" target="_blank" href="https://zeitung.sueddeutsche.de"
                                           className="">Zeitung</a>
                                    </li>
                                    <li className="">
                                        <a id="magazin" target="_blank" href="https://sz-magazin.sueddeutsche.de"
                                           className="">Magazin</a>
                                    </li>
                                    <li className="">
                                        <a id="jetzt" target="_blank" href="https://jetzt.de"
                                           className="">Jetzt</a>
                                    </li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SzTopBar;